<!--
激活银行卡
-->
<template>
    <div>
        <comp-title-dc back-url-name="bankmanager">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/bankmanager' }">银行卡管理</el-breadcrumb-item>
                <el-breadcrumb-item>激活银行卡</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-active-bank bizcomp">
            <div class="header-title">激活银行卡</div>
            <div class="bank-info-contain">
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">银行名称：</el-col>
                    <el-col v-show="bankInfo.bankcode" :span="13" class="font-size-16">
                        {{ $cache.getDict("110080", bankInfo.bankcode) }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">银行卡号：</el-col>
                    <el-col :span="13" class="font-size-16">
                        {{ bankInfo.depositcard }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">银行户名：</el-col>
                    <el-col :span="13" class="font-size-16">
                        {{ banTip ? "" : acctInfo.custname }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">证件类型：</el-col>
                    <el-col :span="13" class="font-size-16">
                        {{ banTip ? "" : $cache.getDict("130007", acctInfo.certificatetype) }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">证件号码：</el-col>
                    <el-col :span="13" class="font-size-16">
                        {{ banTip ? "" : acctInfo.certificateno }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="11" class="text-align-right">联系电话：</el-col>
                    <el-col :span="13" class="font-size-16">
                        <el-input
                            v-model.trim="bankInfo.newMobile"
                            placeholder="请输入联系电话"
                            :maxlength="11"
                        />
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="10" class="text-align-right"></el-col>
                    <el-col :span="14" class="font-size-16 agreement-contain">
                        <agreement
                            v-model="protocol"
                            :data="agrType"
                            v-on:all-read="agreePro"
                        ></agreement>
                    </el-col>
                </el-row>
                <div class="btn-contain">
                    <el-button class="medium" v-on:click="$router.back()">取消</el-button>
                    <el-tooltip :content="btnTip" :manual="!btnTip">
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="!!btnTip"
                            v-on:click="nextStep()"
                        >
                            下一步
                        </el-button>
                    </el-tooltip>
                </div>
            </div>
            <bank-sms-valid
                :dialog-visible="smsVisible"
                :acct-info="acctInfo"
                :bank-info="bankInfo"
                biztype="02"
                v-on:close="smsClose"
                v-on:sms-comfirm="smsConfirm"
            />
        </div>
    </div>
</template>
<script>
import userApi from "@/api/user";
import mixin from "@/assets/js/mixin";
import bankSmsValid from "./bankSmsValid.vue";
import agreement from "@/components/form/agreement.vue";
import { sceneEnum } from "@/util/util_jfit";
export default {
    name: "ActiveBank",
    components: {
        bankSmsValid,
        agreement
    },
    mixins: [mixin],
    data() {
        return {
            acctInfo: {},
            bankInfo: {},
            smsVisible: false,
            banTip: "",
            protocol: false,
            agrType: sceneEnum.activeCard
        };
    },
    computed: {
        btnTip() {
            return this.banTip || this.bankInfo.activeDisabledTip;
        }
    },
    created() {
        this.acctInfo = this.$cache.getUser();
        const id = this.$route.query.id;
        this.bankInfo = {};
        if (this.$cache.getBinded()) {
            userApi
                .getBankCardList()
                .then(({ bankList }) => {
                    const arr = bankList.filter((item) => item.bankcardid === id);
                    if (arr.length > 0) {
                        const _x = arr[0];
                        _x.channelid = _x.paycenterid + "" + _x.bankcode;
                        this.bankInfo = _x;
                        this.$set(this.bankInfo, "newMobile", this.bankInfo.mobileno);
                        this.banTip = "";
                    } else {
                        this.bankInfo = {};
                        this.banTip = "找不到银行卡";
                    }
                })
                .catch(() => {
                    this.bankInfo = {};
                    this.banTip = "找不到银行卡";
                });
        } else {
            this.banTip = "用户未开户";
        }
    },
    methods: {
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            this.smsCheck();
        },
        nextStep() {
            this.smsVisible = false;
            if (!this.bankInfo.newMobile) {
                this.$message.error("请输入手机号码");
                return;
            }
            if (this.bankInfo.newMobile !== this.bankInfo.mobileno) {
                if (!/^(1)(\d{10})$/.test(this.bankInfo.newMobile)) {
                    this.$message.error("请输入真实的手机号");
                    return;
                }
            }
            this.protocol = true;
        },
        smsCheck() {
            if (this.bankInfo.signtype === "0") {
                this.bankCcardPageSigning();
            } else {
                this.smsVisible = false;
                if (this.bankInfo.en_mobileno && this.bankInfo.mobileno) {
                    this.smsVisible = true;
                } else {
                    this.$message.warning("手机号缺失");
                }
            }
        },
        async bankCcardPageSigning() {
            let paramsObj = {};
            let _x = {};
            _x.verifytype = "0";
            _x.biztype = "02";
            _x.paychannel = this.bankInfo.paycenterid;
            // _x.mobileno = this.bankInfo.mobileno;
            _x.channelid = this.bankInfo.channelid;
            _x.channelname = this.bankInfo.channelname;
            _x.bankcardid = this.bankInfo.bankcardid;
            _x.bankcode = this.bankInfo.bankcode;
            _x.certificatetype = this.$cache.getUser().certificatetype;
            if (this.bankInfo.signtype === "0") {
                this.randomToken = this.$util.generateRandomNumber();
                _x.pagecallbackurl =
                    window.location.origin + "" + "/sale-mid-ump/bank/redirect/" + this.randomToken;
                _x.randomtoken = this.randomToken;
                // 建行网联的回调地址配置在银行那边，需要单独处理
                if (this.bankInfo.paycenterid == "0105") {
                    _x.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                }
                paramsObj.signtype = "0";
            }

            if (this.$cache.getIsEncrypted()) {
                _x.en_certificateno = this.$cache.getUser().en_certificateno;
                _x.en_depositname = this.$cache.getUser().en_custname;
                _x.en_custname = this.$cache.getUser().en_custname;
                _x.en_mobileno = this.bankInfo.en_mobileno;
                _x.en_depositcard = this.bankInfo.en_desendepositcard;
            } else {
                _x.certificateno = this.$cache.getUser().certificateno;
                _x.depositname = this.$cache.getUser().custname;
                _x.custname = this.$cache.getUser().custname;
                _x.mobileno = this.bankInfo.newMobile;
                _x.depositcard = this.bankInfo.depositcard;
            }
            paramsObj = Object.assign({}, paramsObj, _x);

            const res = await userApi.sendBindCardSms(paramsObj, this.$cache.getIsEncrypted());
            if (res.data) {
                const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                if (pageParam) {
                    pageParam = JSON.parse(pageParam);
                }
                const bankgateserialno = res.data.bankgateserialno;
                const reqMethod = res.data.method;
                this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                let isDecryptObj = {};
                if (this.$cache.getIsEncrypted()) {
                    isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                    isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                    isDecryptObj.en_depositcard = this.bankInfo.en_depositcard;
                    isDecryptObj.en_mobileno = this.bankInfo.en_mobileno;
                } else {
                    isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                    isDecryptObj.depositname = this.$cache.getUser().custname;
                    isDecryptObj.depositcard = this.bankInfo.depositcard;
                    isDecryptObj.mobileno = this.bankInfo.newMobile;
                }
                const params = {
                    ...isDecryptObj,
                    token: this.randomToken,
                    certificatetype: this.$cache.getUser().certificatetype,
                    bankcode: this.bankInfo.bankcode,
                    // depositcard: this.acctInfo.bankcard,
                    // mobileno: this.acctInfo.newMobile,
                    paychannel: this.bankInfo.paycenterid,
                    bankgateserialno: bankgateserialno,
                    signtype: "0",
                    bankcardid: this.bankInfo.bankcardid
                };
                // if (this.acctInfo.bankcardid) {
                //     params.bankcardid = this.acctInfo.bankcardid;
                // }
                this.$util.confirmBankAuth(this, params, "BankPageAuthentication", async () => {
                    const res = await userApi.combUpdateBankcardAuth(
                        paramsObj,
                        this.$cache.getIsEncrypted()
                    );
                    if (res.code == "0") {
                        this.$router.push({
                            name: "bankmanager"
                        });
                        this.$message.success("银行卡激活成功");
                    }
                });
            }
        },
        smsConfirm() {
            userApi
                .combUpdateBankcardAuth({
                    certificatetype: this.acctInfo.certificatetype,
                    en_certificateno: this.acctInfo.en_certificateno,
                    bankcode: this.bankInfo.bankcode,
                    bankcardid: this.bankInfo.bankcardid,
                    paychannel: this.bankInfo.paycenterid
                })
                .then(() => {
                    this.smsVisible = false;
                    this.$router.push({ name: "bankmanager" });
                    this.$message.success("银行卡激活成功");
                });
        },
        smsClose() {
            this.smsVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-active-bank {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 52px;

    .header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        text-align: center;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }

    .bank-info-contain {
        margin-top: 40px;
        font-size: 14px;
        font-weight: normal;
        color: #333333;

        :deep(.el-input__inner) {
            width: 400px !important;
        }

        .row-common {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
        }

        .agreement-contain {
            padding-left: 50px;
        }

        .btn-contain {
            margin-top: 30px;
            text-align: center;

            .cancel-btn {
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #666666;
                cursor: pointer;
                border: none;
            }

            .confirm-btn {
                margin-left: 40px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                border: none;
                color: #ffffff;
            }

            .confirm-btn-active {
                background: var(--color-primary);
                cursor: pointer;
            }

            .confirm-btn-disabled {
                background: #f7b2b8;
            }
        }
    }

    .font-size-16 {
        font-size: 16px;
    }

    .text-align-right {
        text-align: right;
    }
}
</style>
